export interface EventLocationModalProps {
	isOpen: boolean
	closeModal: () => any
}

export const PAGE: number = 0
export const SIZE: number = 5
export const ROWS_OPTIONS: Array<number> = [5, 10, 15]
